module.exports = __webpack_public_path__ + "assets/img/popular.16dfc34b.png";